import { render } from "./SummaryLayout.vue?vue&type=template&id=279b9fd4&scoped=true&ts=true"
import script from "./SummaryLayout.vue?vue&type=script&lang=ts"
export * from "./SummaryLayout.vue?vue&type=script&lang=ts"

import "./SummaryLayout.vue?vue&type=style&index=0&id=279b9fd4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279b9fd4"]])

export default __exports__